import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import { SidebarItemExpandedExpandableHeaderComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/expandable-header/sidebar-item-expanded-expandable-header.component';
import { SidebarItemExpandedSubpagesComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/subpages/sidebar-item-expanded-subpages.component';
import { SidebarItemExpandedLinkComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/link/sidebar-item-expanded-link.component';

@Component({
  selector: 'app-sidebar-item-expanded',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    SidebarItemExpandedLinkComponent,
    SidebarItemExpandedExpandableHeaderComponent,
    SidebarItemExpandedSubpagesComponent,
  ],
  template: `
    @if (subPages()) {
      <li class="my-0.5 flex w-full min-w-0 flex-col overflow-hidden">
        <app-sidebar-item-expanded-expandable-header />

        <div
          class="not-highlightable pb-[0.6rem] pl-[2.6rem]"
          [ngClass]="{ hidden: !isExpanded() && !isActive() }">
          <app-sidebar-item-expanded-subpages />
        </div>
      </li>
    } @else {
      <li class="my-0.5 w-full overflow-hidden">
        <app-sidebar-item-expanded-link />
      </li>
    }
  `,
})
export class SidebarItemExpandedComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  protected readonly subPages = this.store.subPages;

  /****/
  protected readonly isExpanded = this.store.isExpanded;

  /****/
  private readonly _activeRoute = toSignal(this.service.routeChanged$);

  /****/
  protected readonly isActive = computed(() => {
    const subPages = this.subPages();
    return subPages
      ? subPages.some(page => page.path === this._activeRoute())
      : false;
  });
}
